module.exports = __webpack_public_path__ + "img/147.8bb8c0aa.png";